(ns app.domain.sign-off.declarations
  (:require [app.domain.business.model :as business-model]
            [app.domain.party-role.model :as role-model]
            [clojure.string :as str]
            [clojure.walk :as walk]))


(def placeholder->ctx-path
  {"%full-name%" [:party :full-name]
   "%role%"      [:role]})


(def default-declaration-schema
  [:sign-off/declaration-section-v2 {}
   [:sign-off/declaration-subsection {}
    "I, %full-name%, do hereby declare that the information contained in this application, the attached schedules and forms, the attached plans and specifications, and other attached documentation is true to the best of my knowledge. If the owner is a corporation or partnership, I have the authority to bind the corporation or partnership by signing off, I understand that it constitutes a legal signature confirming that I acknowledge and agree to the above declaration."]])


(defn- replace-placeholders [{:keys [tr lang] :as ctx} original-text]
  (reduce (fn [text [placeholder path]]
            (let [v       (get-in ctx path "")
                  final-v (cond
                            (:party-role/key v) (role-model/party-role-name v lang)

                            (and (= placeholder "%full-name%")
                                 (-> ctx :party :party/business))
                            (tr [:signature/signed-for-corporation]
                                [v
                                 (-> ctx :party :party/business (business-model/business-name lang))])

                            (keyword? v) (tr [v])
                            :else v)]
              (str/replace text placeholder final-v)))
          original-text
          placeholder->ctx-path))


(defn process-placeholders [ctx child-nodes]
  (walk/postwalk (fn [node]
                   (if (string? node)
                     (replace-placeholders ctx node)
                     node))
                 child-nodes))
